<p-toggleButton
    [ngClass]="[toggleButtonStyleClass, unToggleable && value ? 'sera-toggle-button--not-toggleable' : '', !onLabel ? 'sera-toggle-button--no-label' : '']"
    [(ngModel)]="value"
    [onIcon]="onIcon"
    [offIcon]="offIcon"
    [iconPos]="iconPos"
    [onLabel]="onLabel | translate"
    [disabled]="disabled"
    [offLabel]="offLabel | translate"
    (onChange)="stateChanged.emit(value)" />
